import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Users, Rocket, HeartHandshake } from "lucide-react";
import { Section, GlassCard, fadeUp, OutlineButton } from "@/components/ui-kit";
import { COMPANY } from "@/lib/api";

const values = [
  { i: HeartHandshake, t: "Driver First", d: "Every decision starts with: is this good for our drivers?" },
  { i: Sparkles, t: "Craft", d: "We obsess over the details — service ops, paperwork, support." },
  { i: Rocket, t: "Long-term", d: "We're here for the next decade, not the next quarter." },
  { i: Users, t: "Respect", d: "Drivers are partners. Everyone here is treated like an adult." },
];

const futureRoles = [
  { t: "Fleet Operations Lead", l: "Hyderabad · Full-time" },
  { t: "Driver Success Manager", l: "Hyderabad · Full-time" },
  { t: "Senior Software Engineer", l: "Remote / Hyderabad · Full-time" },
  { t: "Vehicle Service Specialist", l: "Hyderabad · Full-time" },
];

export default function Careers() {
  return (
    <div data-testid="careers-page">
      <section className="pt-32 pb-16 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <motion.p {...fadeUp} className="text-xs tracking-[0.3em] uppercase text-[#3B82F6]">Careers</motion.p>
          <motion.h1 {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.05 }} className="mt-5 font-display text-5xl md:text-7xl tracking-tighter font-semibold leading-[1.02]">
            Build a fleet company<br/>worth working at.
          </motion.h1>
          <motion.p {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.1 }} className="mt-6 max-w-2xl text-lg text-[#D1D5DB]">
            We're small today and hiring deliberately. If you care about craft, drivers, and building real-world infrastructure — talk to us.
          </motion.p>
        </div>
      </section>

      <Section eyebrow="Culture" title="How we work.">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => (
            <motion.div key={v.t} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }}>
              <GlassCard className="h-full">
                <v.i className="w-5 h-5 text-[#3B82F6]" />
                <h3 className="mt-5 font-display text-xl">{v.t}</h3>
                <p className="mt-2 text-[#9CA3AF]">{v.d}</p>
              </GlassCard>
            </motion.div>
          ))}
        </div>
      </Section>

      <Section eyebrow="Open roles" title="No live openings — but plenty of future ones.">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {futureRoles.map((r, i) => (
            <motion.div key={r.t} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }}>
              <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 flex items-center justify-between">
                <div>
                  <p className="font-display text-xl">{r.t}</p>
                  <p className="text-sm text-[#9CA3AF] mt-1">{r.l}</p>
                </div>
                <span className="text-xs tracking-[0.18em] uppercase text-[#9CA3AF]">Coming soon</span>
              </div>
            </motion.div>
          ))}
        </div>
        <motion.div {...fadeUp} className="mt-10">
          <a href={`mailto:${COMPANY.email}?subject=I'd%20like%20to%20work%20at%20GK%20Fleet`} data-testid="careers-email">
            <OutlineButton>Send us your story →</OutlineButton>
          </a>
        </motion.div>
      </Section>
    </div>
  );
}
